module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/teaching-post/teaching-post.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/teaching-post/teaching-post.png
// module id = 637
// module chunks = 0